import React from "react";
import { useSelector } from "react-redux";

const QuestionInfo = ({
  infoData,
  question,
  questionNo,
  domain,
  mil,
  goal,
}) => {
  return (
    <div className="activiy-log-container questionInfo">
      <p className="domain-name">{domain}</p>
      <h1 className="activiy-log-header">
        {mil && `MIL: ${mil} > `}
        {goal ? `Goal: ${goal} > ` : null}
        {questionNo && `Q: `}
        <strong>{questionNo}</strong>
      </h1>

      <section className="question">{question}</section>
      <div className="form-progress"></div>
      <div
        className="question-info"
        dangerouslySetInnerHTML={{ __html: infoData }}
      />
    </div>
  );
};

export default QuestionInfo;
